export const getAvarege = ArrayOfInt => {
  return ArrayOfInt.length > 0
    ? ArrayOfInt.reduce((a, b) => a + b) / ArrayOfInt.length
    : 0;
};
